import React from "react";
import { Button } from "./ui";
import StickyBar from "./ui/StickyBar";

export function getCreateEventPublishLabel({ loading, isDraft, isEdit, account, organizer }, { compact = false } = {}) {
  organizer = account ?? organizer;
  if (loading) {
    if (isDraft) return "Publishing…";
    if (isEdit) return "Saving…";
    return "Creating…";
  }
  if (compact) {
    if (isDraft) return "Publish →";
    if (isEdit) return "Save →";
    return organizer ? "Create →" : "Sign up →";
  }
  if (isDraft) return "Publish event →";
  if (isEdit) return "Save changes →";
  if (organizer) return "Create event & get link →";
  return "Sign up & publish event →";
}

/**
 * Mobile thumb-zone bar for create/edit event — Save draft + Publish.
 * Desktop uses inline form actions at the end of the scroll.
 */
export default function CreateEventStickyBar({
  formId,
  savingDraft,
  loading,
  publishLabel,
  onSaveDraft,
}) {
  return (
    <StickyBar
      testId="create-event-sticky-bar"
      hideOnDesktop
      aria-busy={loading || savingDraft}
    >
      <div className="flex items-stretch gap-2">
        <Button
          type="button"
          variant="secondary"
          disabled={loading || savingDraft}
          onClick={onSaveDraft}
          className="shrink-0 px-3 text-[13px]"
          data-testid="sticky-save-draft-btn"
        >
          {savingDraft ? "Saving…" : "Save draft"}
        </Button>
        <Button
          type="submit"
          form={formId}
          variant="primary"
          disabled={loading || savingDraft}
          className="flex-1 min-w-0 text-[13px] sm:text-[14px]"
          data-testid="sticky-submit-event-btn"
        >
          <span className="truncate">{publishLabel}</span>
        </Button>
      </div>
    </StickyBar>
  );
}
